<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <b-row class="mb-2">
        <b-col
          cols="12"
          md="3"
          class="mb-1"
        >
          <el-input
            v-model="unitNameParam"
            size="small"
            placeholder="请输用工单位名称"
            clearable
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <el-input
            v-model="queryKey"
            size="small"
            placeholder="请输入岗位名称查询"
            clearable
          />
        </b-col>
        <b-col
          cols="12"
          :md="6"
          class="mb-md-0 mb-2"
        >
          <el-button
            type="primary"
            size="small"
            @click="initPage('search')"
          >查询
          </el-button>
        </b-col>
      </b-row>
      <div class="table-box">
        <el-table
          ref="table"
          :data="tableData"
          class="responsive"
        >
          <el-table-responsive-column
            type="index"
            label="序号"
            width="60"
          />
          <el-table-responsive-column
            prop="name"
            label="岗位名称"
          />
          <el-table-responsive-column
            prop="unit.name"
            label="设岗单位"
          />
          <el-table-responsive-column label="岗位发布日期">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | moment('YYYY-MM-DD') }}</span>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column label="申请截止日期">
            <template slot-scope="scope">
              <span>{{ scope.row.deadTime | moment('YYYY-MM-DD') }}</span>
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="departIntro(scope.row)"
              >单位介绍
              </el-button>
              <el-button
                type="text"
                @click="unitDetail(scope.row)"
              >岗位详情
              </el-button>
              <el-button
                :disabled="scope.row.hasApply"
                type="text"
                @click="Approval(scope.row)"
              >申请
              </el-button>
            </template>
          </el-table-responsive-column>
        </el-table>
      </div>
      <div class="pagenation-box">
        <el-pagination
          :current-page="currentPage + 1"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="totalSize"
          @current-change="handleCurrentChange"
        />
      </div>
      <div class="dialog-box">
        <!--单位介绍-->
        <el-dialog
          title="单位介绍"
          :visible.sync="detailDialogVisible"
        >
          <div style="margin-bottom: 20px">
            单位名称：{{ unitName }}
          </div>
          <div>单位介绍：{{ unitDetailInnerInfo }}</div>
          <el-row style="margin-top:20px;">
            <el-col>已发布岗位</el-col>
            <el-col style="margin-top:10px;">
              <el-table
                :data="unitTableData"
                style="width: 100%"
                border
                max-height="240"
              >
                <el-table-column
                  prop="jobname"
                  label="岗位名称"
                />
                <el-table-column
                  prop="jobType"
                  label="岗位类型"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.jobType | unitType }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="jobNum"
                  label="招聘人数"
                />
                <el-table-column
                  prop="status"
                  label="招聘状态"
                />
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="checkDetails(scope.row)"
                    >查看详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-dialog>
        <!-- 岗位详情 -->
        <unitDetailDialog
          ref="unitDetailDialog"
          :show-apply="true"
          :unit-detail-props="unitDetailProps"
          :app-unit="appUnit"
          @unit="unitView"
        />
        <!-- 申请资料 -->
        <appMateerial
          ref="appMateerial"
          :is-application="true"
          :info-obj="infoObj"
          :can-insert="true"
          :isnt-stu="true"
          @comfirmApplication="comfirmApplication"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import { jobService, commonService } from '@/api/index'
import { getStudentInfo } from '@/api/api'
import { checkName } from '@/tool/utils'
import appMateerial from '@/components/ApplicationMaterials.vue'
import unitDetailDialog from '@/components/UnitDetailDialog.vue'
import { getUserSn } from '@/auth/utils'

export default {
  name: 'Index',
  components: {
    unitDetailDialog,
    appMateerial,
  },
  data() {
    return {
      queryKey: null, // 搜索岗位key
      unitDetailProps: null,
      currentPage: 0,
      totalSize: 1,
      tableData: [],
      detailDialogVisible: false,
      unitName: '',
      unitNameParam: '', // 输入用工单位名称查询
      unitDetailInnerInfo: '',
      jobId: null,
      infoObj: null,
      unitTableData: [],
      rows: '',
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage(type = null) {
      if (type === 'search') {
        this.currentPage = 0
        if (!checkName(this.queryKey) && !checkName(this.unitNameParam)) {
          this.queryTable()
        } else {
          this.$message.warning('请输入正确单位或岗位名称')
        }
      } else {
        this.queryTable()
      }
    },
    queryTable() {
      const params = {
        page: this.currentPage,
        size: 10,
        jobName: this.queryKey,
        unitName: this.unitNameParam,
      }
      jobService()
        ._onRecruit(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.content
            this.totalSize = res.data.totalElements
            this.$refs.table.doLayout()
          }
        })
    },
    // 单位介绍
    departIntro(row) {
      this.rows = row
      this.unitDetailInnerInfo = this.rows.unit.remark
      this.unitName = this.rows.unit.name
      this.detailDialogVisible = true
      // jobService()._recruitDetail(this.rows.unit.id).then(res => {
      //   if (res.status) {
      //     this.unitTableData = res.data.jobList
      //   }
      // })
      this.getunitTableData()
    },
    // 岗位详情
    unitDetail(row) {
      this.rows = row
      this.unitDetailInnerInfo = this.rows.unit.remark
      this.unitName = this.rows.unit.name
      this.jobId = row.id
      const params = {
        name: row.name,
        jobType: row.jobType, // 新增岗位类型
        // 有效期限： 无
        numberOfNeed: row.numberOfNeed, // 岗位招聘人数
        numberOfOn: row.numberOfOn, //  当前已申请人数
        money: row.money, // 月薪
        teacher: row.teacher, // 指导教师
        phone: row.phone, // 联系电话
        endTime: row.endTime,
        pVaiName: row.pVaiName, // 固定岗位有效期
        startTime: row.startTime,
        deadTime: row.deadTime,
        jobContent: row.jobContent, // 岗位职责
        requirements: row.requirements, // 岗位要求
        workDesc: row.workDesc, // 工作时间说明
        hasApply: row.hasApply,
        jobLimitList: row.jobLimitList,
        isStudent: true,
        numberOfWorking: row.numberOfWorking,
        type: 'announcement', // 公告
        file: row.file ? JSON.parse(row.file) : { name: '', path: '' },
      }
      this.unitDetailProps = params
      this.$refs.unitDetailDialog.dialogVisible = true
    },
    // 申请
    Approval(row) {
      getStudentInfo(getUserSn())
        .then(res => {
          if (res.status && res.data) {
            this.jobId = row.id
            const studentInfo = res.data
            this.infoObj = {
              nation: studentInfo.nation,
              gender: studentInfo.gender,
              collegeName: studentInfo.college != null ? studentInfo.college.name : '',
              className: studentInfo.classs != null ? studentInfo.classs.name : '',
              birthday: studentInfo.birthDate,
              mobile: studentInfo.phone,
              email: studentInfo.email,
              realName: studentInfo.name,
            }
            commonService()
              ._getStudentBankCard(getUserSn())
              .then(bankRep => {
                if (bankRep.status) {
                  if (bankRep.data) {
                    Object.assign(this.infoObj, {
                      bankName: bankRep.data.openBank,
                      bankNo: bankRep.data.bankCard,
                    })
                  }
                  this.$refs.appMateerial.dialogVisible = true
                }
              })
          } else {
            this.$message.error('当前学生不籍，无法申请')
          }
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1
      this.queryTable()
    },
    // 申请确认
    comfirmApplication(item) {
      item.jobId = this.jobId
      jobService()
        ._applyUnit(item)
        .then(res => {
          if (res.status) {
            if (res.data) {
              this.$message.success('请注意，您已经处在被雇佣状态，您可以继续填写岗位申请，但只有在您与原单位解除雇佣关系后才能被新单位录用！')
              this.queryTable()
              this.$refs.appMateerial.dialogVisible = false
              return
            }
            this.queryTable()
            this.$message.success('申请成功')
            this.$refs.appMateerial.dialogVisible = false
          }
        })
    },
    appUnit() {
      getStudentInfo(getUserSn())
        .then(res => {
          if (res.status && res.data) {
            const studentInfo = res.data
            this.infoObj = {
              nation: studentInfo.nationId,
              gender: studentInfo.gender,
              collegeName: studentInfo.college != null ? studentInfo.college.name : '',
              className: studentInfo.classs != null ? studentInfo.classs.name : '',
              birthday: studentInfo.birthDate,
              mobile: studentInfo.phone,
              email: studentInfo.email,
              realName: studentInfo.name,
            }
            commonService()
              ._getStudentBankCard(getUserSn())
              .then(bankRep => {
                if (bankRep.status) {
                  this.infoObj.bankNo = bankRep.data.bankCard
                  this.infoObj.bankName = bankRep.data.openBank
                }
              })
            this.$refs.appMateerial.dialogVisible = true
            this.$refs.unitDetailDialog.dialogVisible = false
          }
        })
    },
    checkDetails(row) {
      this.jobId = row.jobId
      this.detailDialogVisible = false
      this.$refs.unitDetailDialog.dialogVisible = true
      const params = {
        name: row.jobname,
        jobType: row.jobType, // 新增岗位类型
        // 有效期限： 无
        numberOfNeed: row.jobNum, // 岗位招聘人数
        numberOfOn: row.appNum, //  当前已申请人数
        money: row.money, // 月薪
        teacher: row.teacher, // 指导教师
        phone: row.phone, // 联系电话
        endTime: row.endTime,
        pVaiName: row.activeLife, // 固定岗位有效期
        startTime: row.startTime,
        deadTime: row.deadTime,
        jobContent: row.jobContent, // 岗位职责
        requirements: row.requirements, // 岗位要求
        workDesc: row.workDesc, // 工作时间说明
        hasApply: row.hasApply,
        jobLimitList: row.jobLimitList,
        isStudent: true,
        type: 'announcement', // 公告
        numberOfWorking: row.numberOfWorking,
      }
      this.unitDetailProps = params
    },
    getunitTableData() {
      this.unitTableData = []
      jobService()
        ._recruitDetail(this.rows.unit.id)
        .then(res => {
          if (res.status && res.data) {
            // console.log(res.data)
            this.unitTableData = res.data.jobList
          }
        })
    },
    unitView() {
      this.getunitTableData()
      this.detailDialogVisible = true
      // this.unitTableData = []
      // this.unitTableData.push(params)
      this.$refs.unitDetailDialog.dialogVisible = false
    },
  },
}
</script>

<style scoped>
</style>
